import { mapState } from 'vuex'

export default {
  props: {
    player: Object,
    badge: String
  },
  computed: {
    ...mapState(['user', 'teams', 'badges', 'superBadges']),
    team () {
      return this.teams[this.player.assignedTeam] || null
    },
    badgesCount () {
      return (this.player.badges || []).filter(b => b !== 'organizer').length
    },
    badgeObj () {
      return [...this.badges, ...this.superBadges].find(b => b.id === this.badge)
    },
    badgeImageName () {
      return this.badgeObj ? this.badgeObj.image : null
    }
  }
}
